import React from 'react'
import "./about.css"
import SocialContact from "../../common/social-contact/index"


function About() {
  
    return (
        <div className="about">
            <div className="about-top">
                <div className="about-info"> 
                    Hello, My name is <br></br>
                     <span className="changeText">Atul Sharma</span> <br></br>
                     
                </div>
                <div className="about-photo">
                    <img src={require('../../../images/myImage.jpeg').default} className="picture" />
                </div>
            </div>
            <div className="about-bottom">
                <SocialContact />
            </div>
        </div>
    )
}

export default About
